'use client';

import { useEffect, useMemo, useRef, useState } from 'react';
import { useScroll } from '@/src/components/global/ScrollContext';
export function useAnchorSpy({
  items,
  offset = 96
}) {
  const {
    scrollY
  } = useScroll();
  const [activeId, setActiveId] = useState(null);
  const positionsRef = useRef([]);
  const idsSignature = useMemo(() => items.map(i => i.id).join('|'), [items]);
  const recalcPositions = () => {
    positionsRef.current = items.map(({
      id
    }) => {
      const el = document.getElementById(id);
      if (!el) return null;
      const rect = el.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      return {
        id,
        top
      };
    }).filter(v => !!v).sort((a, b) => a.top - b.top);
  };
  useEffect(() => {
    const t = setTimeout(recalcPositions, 50);
    const onResize = () => recalcPositions();
    window.addEventListener('resize', onResize);
    window.addEventListener('load', recalcPositions);

    // 이미지 로드 이후 반영
    const images = Array.from(document.images);
    const onImg = () => setTimeout(recalcPositions, 50);
    images.forEach(img => {
      if (!img.complete) {
        img.addEventListener('load', onImg);
        img.addEventListener('error', onImg);
      }
    });
    return () => {
      clearTimeout(t);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', recalcPositions);
      images.forEach(img => {
        img.removeEventListener('load', onImg);
        img.removeEventListener('error', onImg);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idsSignature]);
  useEffect(() => {
    if (!positionsRef.current.length) return;
    const current = scrollY + offset;
    let currentId = positionsRef.current[0].id;
    for (const pos of positionsRef.current) {
      if (pos.top <= current) {
        currentId = pos.id;
      } else {
        break;
      }
    }
    setActiveId(currentId);
  }, [scrollY, offset]);
  return {
    activeId,
    recalcPositions
  };
}